import { Component, inject, ChangeDetectorRef, ViewChild, AfterContentChecked, OnInit, AfterViewInit, signal, QueryList, ViewChildren } from "@angular/core"
import { take } from "rxjs"
import { NotificationService } from "../../common/services/notification.service"
import { BaseViewComponent } from "../base-view.component"
import { AchBillingComponent } from "./ach-billing/ach-billing.component"
import { AutopayPaperlessPaymentComponent } from "./autopay-paperless-payment/autopay-paperless-payment.component"
import { CreditCardBillingComponent } from "./credit-card-billing/credit-card-billing.component"
import { FormValidationService } from "../../common/services/form-validation.service"
import { StateChangedModel } from "../../common/services/state.service"
import { SecureDataService } from "../../common/services/securedata.sevice"
import { LanguageStateService } from "../../common/services/language-state.service"
import { FormControl } from "@angular/forms"
import { AltAutopayPaperlessPaymentComponent } from "./alt-autopay-paperless-payment/alt-autopay-paperless-payment.component"

export enum OrderType {
  AIA = 'AIA',
  FIBER = 'FIBER'
}

export { OrderFlowType } from './order-flow-type';
import { OrderFlowType } from './order-flow-type';

export interface ABPData {
  todaysChargesTotal?: number;
  autopayEnrollment?: boolean
  paperlessEnrollment?: boolean
  paymentAllowAch?: boolean
  samePaymentMethod?: boolean
  autopayEnrollmentTerms?: string
  paperlessEnrollmentTerms?: string
  autopayConsentHtml?: string
  autopayTermsHtml?: string
  paperlessConsentHtml?: string
  hasTodaysCharges?: boolean,
  flowType?: OrderFlowType,
  serviceAvailabilityZipCode?: string;
  isValid?: boolean;
  paymentMustMatchZipCode?: boolean;
  useAlternateComponent?: boolean;
  isOofAutopay?: boolean;
  providerLabel?: string;
  lockAutopayToggle?: boolean;
  hidePaperless?: boolean;
}

@Component({
    selector: 'app-payment-information-entry',
    templateUrl: './payment-information-entry.component.html',
    styleUrl: './payment-information-entry.component.scss',
    standalone: false
})
export class PaymentInformationEntryComponent extends BaseViewComponent implements OnInit, AfterViewInit, AfterContentChecked {

  languageService: LanguageStateService = inject(LanguageStateService)
  protected override onSecureDataChanged(val: StateChangedModel): void {
    if (val.Type == 'PaymentInformationEntry' && val.Data != undefined) {
      const rawData = val.Data;
      if (rawData && typeof rawData == 'object') {
        this.oofFeesAmount = Number(rawData['oofFeesAmount'] || 0)
        this.todaysChargesTotal.set(Number(rawData['todaysChargesTotal'] || 0) + this.oofFeesAmount)
        this.abpData = rawData['abpList'] || [];
        this.abpData = this.abpData.map(item => ({
          ...item,
           providerLabel: item.providerLabel || rawData['internetProvider'] || ''
        }));
        this.customerName = rawData['CreditCardHolderName'] || '';
        this.completedFlows = rawData['completedFlows'] || [];
        this.internetTodaysCharges = Number(rawData['internetTodaysCharges'] || 0) + this.oofFeesAmount;
        this.wirelessTodaysCharges = rawData['wirelessTodaysCharges'] || 0;
        this.videoTodaysCharges = rawData['videoTodaysCharges'] || 0;
        this.paymentAllowAchTodaysCharges = rawData['paymentAllowAchTodaysCharges'] || false;
        this.isResidentialVideo = rawData['isResidentialVideo'] || false;
        this.isCommercial = rawData['isCommercial'] || false;
        this.dtvStreamPackageSelected = rawData['dtvStreamPackageSelected'] || null;
        this.paymentTerms = rawData['paymentTerms'] || '';
        this.paymentIFrameUrl = rawData['paymentIFrameUrl'] || '';
        this.isIframePayment = !!this.paymentIFrameUrl;
      }

    }
  }

  activeTabIndex = [0]
  showErrors = false
  orderType: string
  toastrService = inject(NotificationService)
  formValidationService = inject(FormValidationService)
  secureDataService = inject(SecureDataService)

  showCancelDialog = false

  cdr = inject(ChangeDetectorRef)
  todaysChargesTotal = signal(0)
  public termsAccepted = false

  @ViewChildren(AutopayPaperlessPaymentComponent, { read: AutopayPaperlessPaymentComponent })
  autopayPaperlessPaymentComponents: QueryList<AutopayPaperlessPaymentComponent | AltAutopayPaperlessPaymentComponent>;

  @ViewChild('todayChargesCreditCardBilling')
  todayChargesCreditCardBillingComponent: CreditCardBillingComponent

  @ViewChild('todayChargesAchBilling')
  todayChargesAchBillingComponent: AchBillingComponent


  paymentErrorDialogTitle: string
  paymentErrorDialogVisible = false
  paymentErrorDialogMessage: string
  paymentAuthorizationDialog = false


  abpData: ABPData[] = []
  completedFlows = []
  oofFeesAmount = 0
  customerName = ''
  internetTodaysCharges = 0
  wirelessTodaysCharges = 0
  videoTodaysCharges = 0
  paymentAllowAchTodaysCharges = false
  isResidentialVideo = false
  isCommercial = false
  dtvStreamPackageSelected: any
  paymentTerms = ''
  payWithAchTodaysChargesControl = new FormControl<boolean>(false)
  paymentIFrameUrl = ''
  isIframePayment = false

  // ServiceAvailabilityZipCode: string = ''
  // PaymentZipMustMatchService = false
  // autopayEnrollmentTermsUrl = ''
  // paperlessEnrollmentTermsUrl = ''
  // autopaySelection = false
  // paymentAllowAch = false

  constructor() {
    super()
  }

  ngAfterViewInit(): void {
    this.subscriptions.add(this.todayChargesCreditCardBillingComponent?.creditCardForm.valueChanges.subscribe(() => {
      this.autopayPaperlessPaymentComponents.forEach(item => item.autopayPaperlessPaymentForm.get('samePaymentMethod')?.setValue(false))
    }))
  }

  ngAfterContentChecked() {
    try {
      this.cdr.detectChanges()
    } catch {
      // Handle or log error if needed
    }
  }

  visibleAbpData(): ABPData[] {
    if (!this.isIframePayment) {
      return this.abpData;
    }
    return this.abpData.filter(item => item.flowType !== OrderFlowType.Internet);
  }

  istodayChargesFormValid() {
    // If today's charges are 0, then form is automatically valid
    if (this.todaysChargesTotal() === 0 && !this.isResidentialVideo) {
      return true
    }
    // Otherwise, check terms, credit card form validity AND card validation status
    return this.termsAccepted &&
      ((this.todayChargesAchBillingComponent?.achForm
        && this.formValidationService.isFormValid(this.todayChargesAchBillingComponent?.achForm)) ||
      (this.todayChargesCreditCardBillingComponent?.creditCardForm && this.formValidationService.isFormValid(this.todayChargesCreditCardBillingComponent?.creditCardForm) &&
      this.todayChargesCreditCardBillingComponent?.isValidCard))
  }

  isAutopayPaperlessFormForComponentValid(component: AutopayPaperlessPaymentComponent) {
    const autopayPaperlessForm = component?.autopayPaperlessPaymentForm
    const creditCardBillingComponent = component?.creditCardBillingComponent
    const achBillingComponent = component?.achBillingComponent

    const isCardPaymentValid = creditCardBillingComponent?.creditCardForm.valid &&
      creditCardBillingComponent.isValidCard

    const isAutopayPaperlessFormValid = autopayPaperlessForm?.get('autopayEnrollment').value ?
      (autopayPaperlessForm.get('samePaymentMethod')?.value ||
        (isCardPaymentValid || achBillingComponent?.achForm.valid)) &&
      autopayPaperlessForm.valid : autopayPaperlessForm?.valid

    return isAutopayPaperlessFormValid
  }

  isAutopayPaperlessFormValid(): boolean {
    let returnVal = true;
    if (!this.autopayPaperlessPaymentComponents) {
      return false;
    }
    for (const component of this.autopayPaperlessPaymentComponents) {

      const isAutopayPaperlessFormValid = this.isAutopayPaperlessFormForComponentValid(component)

      if (!isAutopayPaperlessFormValid) {
        returnVal = false;
        break;
      }
    }
    return returnVal
  }


  onSubmitClicked() {
    this.showErrors = false
    if (!this.istodayChargesFormValid() || !this.isAutopayPaperlessFormValid()) {
      this.autopayPaperlessPaymentComponents.forEach(component => {
        component.autopayPaperlessPaymentForm?.markAllAsTouched();
        this.todayChargesCreditCardBillingComponent?.creditCardForm.markAllAsTouched();
        component.achBillingComponent?.achForm.markAllAsTouched();
        component.creditCardBillingComponent?.creditCardForm.markAllAsTouched();
        this.formValidationService.validateForm(this.todayChargesCreditCardBillingComponent?.creditCardForm);
        this.formValidationService.validateForm(component.autopayPaperlessPaymentForm);
        this.formValidationService.validateForm(component.achBillingComponent?.achForm);
        component.creditCardBillingComponent?.validateCardIfNotChecked();
      })
      this.showErrors = true
      this.todayChargesCreditCardBillingComponent?.creditCardForm?.markAllAsTouched();
      this.todayChargesAchBillingComponent?.achForm?.markAllAsTouched();
      this.formValidationService.validateForm(this.todayChargesCreditCardBillingComponent?.creditCardForm);
      this.formValidationService.validateForm(this.todayChargesAchBillingComponent?.achForm);
      this.todayChargesCreditCardBillingComponent?.validateCardIfNotChecked();
      this.scrollToInvalidControl();
      return
    }
    let internetPaymentDetails = null;
    let wirelessPaymentDetails = null;
    let videoPaymentDetails = null;

    for (const flow of this.completedFlows) {

      const flowType = this.determineFlowType(flow.key) as OrderFlowType;
      switch (flowType) {
        case OrderFlowType.Internet: {
          const todaysInternetCharge = this.internetTodaysCharges;
          internetPaymentDetails = this.dynamicPaymentDetails(todaysInternetCharge, flowType);
          break;
        }
        case OrderFlowType.Wireless: {
          const todaysWirelessCharge = this.wirelessTodaysCharges;
          wirelessPaymentDetails = this.dynamicPaymentDetails(todaysWirelessCharge, flowType);
          break;
        }
        case OrderFlowType.Video: {
          const todaysVideoCharge = this.videoTodaysCharges;
          videoPaymentDetails = this.dynamicPaymentDetails(todaysVideoCharge, flowType);
          break;
        }
      }
    }

    const data = {
      internetPaymentDetails,
      wirelessPaymentDetails,
      videoPaymentDetails
    }

    this.secureDataService.submitCustomerData(data, 'PaymentInformationEntry')
      .subscribe({
        next: () => {
          this.navigateWaiting();
        },
        error: (err) => {
          this.notificationService.showError(err);
        }
      });
  }

  determineFlowType(flowKey: string): OrderFlowType {
    switch (flowKey) {
      case 'INTERNET':
        return OrderFlowType.Internet;
      case 'WIRELESS':
        return OrderFlowType.Wireless;
      case 'VIDEO':
        return OrderFlowType.Video;
      default:
        return null;
    }
  }


  private dynamicPaymentDetails(todaysCharge: number, flowType: OrderFlowType): { paymentDetails: any; achPaymentDetails: any } {
    const paymentDetails = this.buildPaymentDetails(todaysCharge, flowType)
    const achPaymentDetails = this.buildAchPaymentDetails(todaysCharge, flowType);
    if (!paymentDetails?.length && !achPaymentDetails?.length) {
      return { paymentDetails: null, achPaymentDetails: null }
    }
    return { paymentDetails, achPaymentDetails }
  }

  onCancelClick() {
    this.showCancelDialog = true;
  }

  onCancel(data: unknown) {
    this.showCancelDialog = false;
    if (data && (data as { data: { success: boolean } }).data?.success) {
      this.subscriptions.add(this.secureDataService.cancel('PaymentInformationEntry-Cancel').pipe(take(1)).subscribe(
        {
          next: () => {
            this.navigateWaiting(true);
          },
          error: (err) => this.onCancelError('PaymentInformationEntry-Cancel', err)
        }))
    }
    // console.log(data);
  }


  private buildPaymentDetails(todaysCharge: number, flowType: OrderFlowType) {
    const paymentDetails = []
    const autopayPaperlessPaymentComponent = this.autopayPaperlessPaymentComponents?.find(component => component.orderFlowType === flowType);
    // Add today's charges payment details if amount > 0
    if ((todaysCharge > 0 || (this.isResidentialVideo && flowType === OrderFlowType.Video)) &&
      this.todayChargesCreditCardBillingComponent?.creditCardForm) { // skip if ach
      paymentDetails.push(this.constructPaymentDetails(this.todayChargesCreditCardBillingComponent, 'today', todaysCharge.toString(), flowType))
    }

    // Add autopay payment details if enabled
    const abpForm = autopayPaperlessPaymentComponent?.autopayPaperlessPaymentForm
    if (abpForm?.get('autopayEnrollment').value) {
      if (abpForm.get('samePaymentMethod').value) {
        paymentDetails.push(this.constructPaymentDetails(this.todayChargesCreditCardBillingComponent, 'abp', "0", flowType))
      } else if (!abpForm.get('payWithAch').value) {
        paymentDetails.push(this.constructPaymentDetails(autopayPaperlessPaymentComponent.creditCardBillingComponent, 'abp', "0", flowType))
      }
    }

    return paymentDetails
  }


  private buildAchPaymentDetails(todaysCharge: number, flowType: OrderFlowType) {
    const achPaymentDetails = []
    if (this.payWithAchTodaysChargesControl.value) {
      achPaymentDetails.push(this.constructACHPaymentDetails(this.todayChargesAchBillingComponent, 'today', todaysCharge.toString(), flowType))
    }
    if (!this.autopayPaperlessPaymentComponents.length) {
      return achPaymentDetails
    }
    const autopayPaperlessPaymentComponent = this.autopayPaperlessPaymentComponents?.find(component => component.orderFlowType === flowType);

    const abpForm = autopayPaperlessPaymentComponent?.autopayPaperlessPaymentForm

    // Add autopay payment details if enabled
    if (abpForm?.get('autopayEnrollment')?.value) {
      if (abpForm.get('payWithAch')?.value) {
        achPaymentDetails.push(this.constructACHPaymentDetails(autopayPaperlessPaymentComponent?.achBillingComponent, 'abp', "0", flowType))
      }
    }

    return achPaymentDetails
  }

  private constructPaymentDetails(creditCardComponent: CreditCardBillingComponent, payType, amount, flowType?: OrderFlowType) {
    const form = creditCardComponent.creditCardForm
    const expirationDate = form.get('expirationDate')?.value
    const [expMonth, expYear] = expirationDate.split('/')

    return {
      PayType: payType,
      Service: this.determineServiceType(flowType),
      Amount: amount,
      CreditCardType: creditCardComponent.cardType,
      CreditCardNumber: creditCardComponent.cardNumberRaw,
      CardHolderName: form.get('cardholderName')?.value,
      ExpirationMonth: expMonth,
      ExpirationYear: expYear,
      Cvv: creditCardComponent.cvvRaw,
      CardHolderZip: creditCardComponent.zipCodeRaw
    }
  }

  private constructACHPaymentDetails(abpAchBillingComponent: AchBillingComponent, payType, amount, flowType: OrderFlowType) {
    const form = abpAchBillingComponent.achForm

    return {
      PayType: payType,
      Service: this.determineServiceType(flowType),
      Amount: amount,
      AccountType: form.get('accountType').value,
      AccountName: form.get('acctHolderName').value,
      AccountNumber: form.get('acctNumber').value,
      RoutingNumber: form.get('routingNumber').value,
    }
  }

  isAutopayPaperlessFormForComponentValidByIndex(index: number) {
    if (index < 0) {
      return false;
    }
    const component = this.autopayPaperlessPaymentComponents?.toArray()[index];
    return this.isAutopayPaperlessFormForComponentValid(component)
  }

  private determineServiceType(flowType: OrderFlowType): string {
    switch (flowType) {
      case OrderFlowType.Internet:
        return "internet";
      case OrderFlowType.Wireless:
        return "wireless";
      case OrderFlowType.Video:
        return "video";
      default:
        return "unknown";
    }
  }

}
